<div class="min-h-screen bg-gradient-to-br from-gray-50 to-blue-50 p-6">
  <div class="container mx-auto px-4">
    <!-- Titre centré -->
    <div class="flex justify-center items-center my-8">
      <app-page-title [titleKey]="'rdvparental.title'"></app-page-title>
    </div>

    <!-- Sélecteur d'élèves -->
    <app-children-selector
      [autoSelectFirst]="true"
      (studentSelected)="onStudentSelected($event)"
    >
    </app-children-selector>

    <!-- Indicateur de chargement -->
    <div *ngIf="loading" class="text-center py-8">
      <div
        class="inline-block animate-spin rounded-full h-12 w-12 border-4 border-[#009688] border-t-transparent"
      ></div>
      <p class="mt-4 text-gray-600">{{ "rdvparental.loading" | translate }}</p>
    </div>

    <!-- Message d'information -->
    <div *ngIf="message" class="my-6">
      <div
        [ngClass]="{
          'bg-green-50 border-green-200 text-green-800':
            messageType === 'success',
          'bg-red-50 border-red-200 text-red-800': messageType === 'error',
          'bg-blue-50 border-blue-200 text-blue-800': messageType === 'info',
          'bg-yellow-50 border-yellow-200 text-yellow-800':
            messageType === 'warning',
        }"
        class="rounded-xl p-4 border shadow-sm"
      >
        <div class="flex items-center gap-2">
          <mat-icon>
            {{
              messageType === "success"
                ? "check_circle"
                : messageType === "error"
                  ? "error"
                  : messageType === "warning"
                    ? "warning"
                    : "info"
            }}
          </mat-icon>
          <span>{{ message }}</span>
        </div>
      </div>
    </div>

    <!-- Statistiques (optionnel) -->
    <div
      *ngIf="
        !loading &&
        selectedStudent &&
        (availableAppointments.length > 0 ||
          confirmedReservations.length > 0 ||
          notConfirmedReservations.length > 0)
      "
      class="mt-8"
    >
      <div class="bg-white rounded-xl p-6 shadow-lg">
        <h3 class="text-lg font-semibold text-[#009688] mb-4">
          {{ "rdvparental.summary" | translate }}
        </h3>
        <div class="grid grid-cols-1 md:grid-cols-3 gap-4">
          <div
            class="text-center p-4 rounded-lg bg-blue-50 border border-blue-100"
          >
            <div class="text-2xl font-bold text-[#009688]">
              {{ availableAppointments.length }}
            </div>
            <div class="text-sm text-gray-600">
              {{ "rdvparental.availableStat" | translate }}
            </div>
          </div>
          <div
            class="text-center p-4 rounded-lg bg-green-50 border border-green-100"
          >
            <div class="text-2xl font-bold text-[#009688]">
              {{ confirmedReservations.length }}
            </div>
            <div class="text-sm text-gray-600">
              {{ "rdvparental.confirmedStat" | translate }}
            </div>
          </div>
          <div
            class="text-center p-4 rounded-lg bg-yellow-50 border border-yellow-100"
          >
            <div class="text-2xl font-bold text-[#009688]">
              {{ notConfirmedReservations.length }}
            </div>
            <div class="text-sm text-gray-600">
              {{ "rdvparental.pendingStat" | translate }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Grille des rendez-vous EN HAUT -->
    <div
      *ngIf="!loading && selectedStudent"
      class="grid grid-cols-1 lg:grid-cols-3 gap-6 items-start mb-8 mt-8"
    >
      <!-- Créneaux disponibles -->
      <div
        class="bg-white shadow-lg rounded-xl p-4 relative border-t-4 border-blue-500"
      >
        <!-- Badge Nouveau -->
        <div
          *ngIf="hasNewSlots"
          class="absolute -top-3 -right-3 bg-blue-600 text-white text-xs font-bold px-3 py-1 rounded-full shadow-md"
        >
          {{ "rdvparental.newBadge" | translate }}
        </div>

        <!-- En-tête -->
        <div class="flex justify-between items-center mb-4">
          <div>
            <span class="font-bold text-[#009688] block max-w-[300px]">
              {{ "rdvparental.availableSlots" | translate }}
            </span>
            <span class="text-[#009688] text-sm ml-2"
              >{{ availableAppointments.length }}
              {{ "rdvparental.slotsLabel" | translate }}</span
            >
          </div>
        </div>

        <!-- Liste des créneaux avec pagination -->
        <div
          *ngIf="availableAppointments.length > 0; else noSlots"
          class="space-y-4"
        >
          <!-- Liste des créneaux paginés -->
          <div
            *ngFor="
              let slot of availableAppointments
                | slice
                  : (availableCurrentPage - 1) * itemsPerPage
                  : availableCurrentPage * itemsPerPage
            "
            class="bg-white border border-gray-200 rounded-lg p-4 hover:shadow-md transition-shadow"
          >
            <div class="font-bold text-gray-800 mb-2">{{ slot.name }}</div>
            <div class="text-sm text-gray-600 mb-3">
              <div class="flex items-center gap-2 mb-1">
                <span class="text-sm text-[#009688]"
                  >{{ "rdvparental.time" | translate }}:</span
                >
                {{ formatAppointmentHour(slot.beginHour) }} - {{ formatAppointmentHour(slot.endHour) }}
              </div>
              <div class="flex items-center gap-2">
                <span class="text-sm text-[#009688]"
                  >{{ "rdvparental.date" | translate }}:</span
                >
                {{ slot.dateDebut | date: "dd-MM-yyyy" }}
              </div>
            </div>
            <div class="text-xs text-gray-500 mb-4">
              {{ slot.nameTeacher }} • {{ slot.nameType }}
            </div>
            <button
              [disabled]="isAlreadyReserved(slot)"
              (click)="reserveAppointment(slot)"
              class="w-full bg-gradient-to-r from-[#009688] to-teal-600 text-white px-4 py-2 rounded-lg hover:from-teal-600 hover:to-[#009688] transition-all duration-300 flex items-center justify-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed disabled:pointer-events-none"
            >
              <span class="material-icons text-lg"></span>
              <span class="font-semibold">{{
                isAlreadyReserved(slot)
                  ? ("rdvparental.alreadyReserved" | translate)
                  : ("rdvparental.reserve" | translate)
              }}</span>
            </button>
          </div>

          <!-- Pagination pour les créneaux disponibles -->
          <div
            *ngIf="availableAppointments.length > itemsPerPage"
            class="flex justify-center items-center space-x-1 mt-4"
          >
            <button
              (click)="previousPage('available')"
              [disabled]="availableCurrentPage === 1"
              class="w-8 h-8 flex items-center justify-center rounded-md bg-teal-50 border border-teal-200 hover:bg-teal-100 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
            >
              <svg
                class="w-4 h-4 text-teal-600"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M15 19l-7-7 7-7"
                ></path>
              </svg>
            </button>

            <ng-container *ngFor="let page of getVisiblePages('available')">
              <span
                *ngIf="page === '...'"
                class="w-8 h-8 flex items-center justify-center text-gray-500 text-sm"
              >
                ...
              </span>
              <button
                *ngIf="page !== '...'"
                (click)="goToPage(+page, 'available')"
                [class]="
                  availableCurrentPage === +page
                    ? 'w-8 h-8 flex items-center justify-center rounded-md bg-[#009688] text-white text-sm font-bold border border-[#009688]'
                    : 'w-8 h-8 flex items-center justify-center rounded-md bg-white text-black text-sm border border-gray-200 hover:bg-gray-50 hover:border-gray-300 transition-colors'
                "
              >
                {{ page }}
              </button>
            </ng-container>

            <button
              (click)="nextPage('available')"
              [disabled]="availableCurrentPage === availableTotalPages"
              class="w-8 h-8 flex items-center justify-center rounded-md bg-teal-50 border border-teal-200 hover:bg-teal-100 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
            >
              <svg
                class="w-4 h-4 text-teal-600"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M9 5l7 7-7 7"
                ></path>
              </svg>
            </button>
          </div>
        </div>
        <ng-template #noSlots>
          <div class="text-center py-6">
            <span class="material-icons text-gray-300 text-4xl mb-2"
              >event_busy</span
            >
            <p class="text-gray-500">{{ "rdvparental.noSlots" | translate }}</p>
          </div>
        </ng-template>
      </div>

      <!-- Réservations confirmées -->
      <div
        class="bg-white shadow-lg rounded-xl p-4 relative border-t-4 border-green-500"
      >
        <!-- En-tête -->
        <div class="flex justify-between items-center mb-4">
          <div>
            <span class="font-bold text-[#009688] block max-w-[300px]">
              {{ "rdvparental.confirmedReservations" | translate }}
            </span>
            <span class="text-[#009688] text-sm ml-2"
              >{{ confirmedReservations.length }}
              {{ "rdvparental.confirmedCount" | translate }}</span
            >
          </div>
        </div>

        <!-- Liste des réservations confirmées avec pagination -->
        <div
          *ngIf="confirmedReservations.length > 0; else noConfirmed"
          class="space-y-4"
        >
          <div
            *ngFor="
              let res of confirmedReservations
                | slice
                  : (confirmedCurrentPage - 1) * itemsPerPage
                  : confirmedCurrentPage * itemsPerPage
            "
            class="bg-white border border-gray-200 rounded-lg p-4 hover:shadow-md transition-shadow"
          >
            <div class="font-bold text-gray-800 mb-2">{{ res.name }}</div>
            <div class="text-sm text-gray-600 mb-3">
              <div class="flex items-center gap-2 mb-1">
                <span class="text-sm text-[#009688]"
                  >{{ "rdvparental.time" | translate }}:</span
                >
                {{ formatAppointmentHour(res.beginHour) }} - {{ formatAppointmentHour(res.endHour) }}
              </div>
              <div class="flex items-center gap-2">
                <span class="text-sm text-[#009688]"
                  >{{ "rdvparental.date" | translate }}:</span
                >
                {{ res.dateDebut | date: "dd-MM-yyyy" }}
              </div>
            </div>
            <div class="text-xs text-gray-500">
              {{ res.nameTeacher }} • {{ res.nameType }}
            </div>
            <div class="mt-3 pt-3 border-t border-green-100">
              <div class="flex items-center gap-2 text-sm text-green-600">
                {{ "rdvparental.confirmedLabel" | translate }}
              </div>
            </div>
          </div>

          <!-- Pagination pour les réservations confirmées -->
          <div
            *ngIf="confirmedReservations.length > itemsPerPage"
            class="flex justify-center items-center space-x-1 mt-4"
          >
            <button
              (click)="previousPage('confirmed')"
              [disabled]="confirmedCurrentPage === 1"
              class="w-8 h-8 flex items-center justify-center rounded-md bg-teal-50 border border-teal-200 hover:bg-teal-100 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
            >
              <svg
                class="w-4 h-4 text-teal-600"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M15 19l-7-7 7-7"
                ></path>
              </svg>
            </button>

            <ng-container *ngFor="let page of getVisiblePages('confirmed')">
              <span
                *ngIf="page === '...'"
                class="w-8 h-8 flex items-center justify-center text-gray-500 text-sm"
              >
                ...
              </span>
              <button
                *ngIf="page !== '...'"
                (click)="goToPage(+page, 'confirmed')"
                [class]="
                  confirmedCurrentPage === +page
                    ? 'w-8 h-8 flex items-center justify-center rounded-md bg-[#009688] text-white text-sm font-bold border border-[#009688]'
                    : 'w-8 h-8 flex items-center justify-center rounded-md bg-white text-black text-sm border border-gray-200 hover:bg-gray-50 hover:border-gray-300 transition-colors'
                "
              >
                {{ page }}
              </button>
            </ng-container>

            <button
              (click)="nextPage('confirmed')"
              [disabled]="confirmedCurrentPage === confirmedTotalPages"
              class="w-8 h-8 flex items-center justify-center rounded-md bg-teal-50 border border-teal-200 hover:bg-teal-100 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
            >
              <svg
                class="w-4 h-4 text-teal-600"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M9 5l7 7-7 7"
                ></path>
              </svg>
            </button>
          </div>
        </div>
        <ng-template #noConfirmed>
          <div class="text-center py-6">
            <span class="material-icons text-gray-300 text-4xl mb-2"
              >event_available</span
            >
            <p class="text-gray-500">
              {{ "rdvparental.noConfirmedReservations" | translate }}
            </p>
          </div>
        </ng-template>
      </div>

      <!-- Réservations non confirmées -->
      <div
        class="bg-white shadow-lg rounded-xl p-4 relative border-t-4 border-yellow-500"
      >
        <!-- En-tête -->
        <div class="flex justify-between items-center mb-4">
          <div>
            <span class="font-bold text-[#009688] block max-w-[300px]">
              {{ "rdvparental.notConfirmedReservations" | translate }}
            </span>
            <span class="text-[#009688] text-sm ml-2"
              >{{ notConfirmedReservations.length }}
              {{ "rdvparental.pendingCount" | translate }}</span
            >
          </div>
        </div>

        <!-- Liste des réservations non confirmées avec pagination -->
        <div
          *ngIf="notConfirmedReservations.length > 0; else noNotConfirmed"
          class="space-y-4"
        >
          <div
            *ngFor="
              let res of notConfirmedReservations
                | slice
                  : (pendingCurrentPage - 1) * itemsPerPage
                  : pendingCurrentPage * itemsPerPage
            "
            class="bg-white border border-gray-200 rounded-lg p-4 hover:shadow-md transition-shadow"
          >
            <div class="font-bold text-gray-800 mb-2">{{ res.name }}</div>
            <div class="text-sm text-gray-600 mb-3">
              <div class="flex items-center gap-2 mb-1">
                <span class="text-sm text-[#009688]"
                  >{{ "rdvparental.time" | translate }}:</span
                >
                {{ formatAppointmentHour(res.beginHour) }} - {{ formatAppointmentHour(res.endHour) }}
              </div>
              <div class="flex items-center gap-2">
                <span class="text-sm text-[#009688]"
                  >{{ "rdvparental.date" | translate }}:</span
                >
                {{ res.dateDebut | date: "dd-MM-yyyy" }}
              </div>
            </div>
            <div class="text-xs text-gray-500">
              {{ res.nameTeacher }} • {{ res.nameType }}
            </div>
            <div class="mt-3 pt-3 border-t border-yellow-100">
              <div class="flex items-center gap-2 text-sm text-yellow-600">
                {{ "rdvparental.pendingConfirmation" | translate }}
              </div>
            </div>
          </div>

          <!-- Pagination pour les réservations non confirmées -->
          <div
            *ngIf="notConfirmedReservations.length > itemsPerPage"
            class="flex justify-center items-center space-x-1 mt-4"
          >
            <button
              (click)="previousPage('pending')"
              [disabled]="pendingCurrentPage === 1"
              class="w-8 h-8 flex items-center justify-center rounded-md bg-teal-50 border border-teal-200 hover:bg-teal-100 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
            >
              <svg
                class="w-4 h-4 text-teal-600"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M15 19l-7-7 7-7"
                ></path>
              </svg>
            </button>

            <ng-container *ngFor="let page of getVisiblePages('pending')">
              <span
                *ngIf="page === '...'"
                class="w-8 h-8 flex items-center justify-center text-gray-500 text-sm"
              >
                ...
              </span>
              <button
                *ngIf="page !== '...'"
                (click)="goToPage(+page, 'pending')"
                [class]="
                  pendingCurrentPage === +page
                    ? 'w-8 h-8 flex items-center justify-center rounded-md bg-[#009688] text-white text-sm font-bold border border-[#009688]'
                    : 'w-8 h-8 flex items-center justify-center rounded-md bg-white text-black text-sm border border-gray-200 hover:bg-gray-50 hover:border-gray-300 transition-colors'
                "
              >
                {{ page }}
              </button>
            </ng-container>

            <button
              (click)="nextPage('pending')"
              [disabled]="pendingCurrentPage === pendingTotalPages"
              class="w-8 h-8 flex items-center justify-center rounded-md bg-teal-50 border border-teal-200 hover:bg-teal-100 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
            >
              <svg
                class="w-4 h-4 text-teal-600"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M9 5l7 7-7 7"
                ></path>
              </svg>
            </button>
          </div>
        </div>
        <ng-template #noNotConfirmed>
          <div class="text-center py-6">
            <span class="material-icons text-gray-300 text-4xl mb-2"
              >hourglass_full</span
            >
            <p class="text-gray-500">
              {{ "rdvparental.noNotConfirmedReservations" | translate }}
            </p>
          </div>
        </ng-template>
      </div>
    </div>

    <!-- Aucun élève sélectionné -->
    <div *ngIf="!loading && !selectedStudent" class="text-center py-12">
      <div class="bg-white rounded-xl p-8 shadow-lg max-w-md mx-auto">
        <span class="material-icons text-gray-300 text-6xl mb-4"
          >person_search</span
        >
        <h3 class="text-xl font-semibold text-gray-700 mb-2">
          {{ "rdvparental.selectStudent" | translate }}
        </h3>
        <p class="text-gray-500">
          {{ "rdvparental.selectStudentDescription" | translate }}
        </p>
      </div>
    </div>
  </div>
</div>
